module.exports = __webpack_public_path__ + "static/img/1.9c7daac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/1.png
// module id = nitP
// module chunks = 0